import { WorkspaceClass, WorkspacesApi } from '@emilgroup/auth-sdk';
import { ACCOUNT_HEADER, AuthMode, usesSession } from 'Services/api/auth/base';

// The SDK's own name for this reply changed between versions (a typo was fixed).
type ListWorkspacesReply = { workspaces?: WorkspaceClass[] };

const listWithCookie = async ( apiUrl: string, sub?: string ): Promise<WorkspaceClass[]> => {
  const response = await fetch(
    new URL( 'authservice/v1/workspaces', apiUrl ).toString(),
    { credentials: 'include', ...( sub && { headers: { [ACCOUNT_HEADER]: sub } } ) },
  );
  if ( !response.ok ) {
    throw new Error( `Listing workspaces with the access cookie failed: ${ response.status }` );
  }
  const body: ListWorkspacesReply = await response.json();

  return body?.workspaces || [];
};

/** Read with the access cookie (dual) or the session cookie; the SDK stays the fallback. */
export const listWorkspaces = async (
  authMode: AuthMode | undefined,
  loggedInAccounts: number,
  workspaceService: WorkspacesApi,
  apiUrl: string,
  onCookieError?: ( error: unknown ) => void,
  sub?: string,
): Promise<WorkspaceClass[]> => {
  // The browser holds one access cookie; with several accounts it may belong to another one.
  if ( authMode === 'dual' && loggedInAccounts === 1 ) {
    try {
      return await listWithCookie( apiUrl );
    } catch ( error ) {
      onCookieError?.( error );
    }
  }
  // A session holds every account; the header says which one.
  if ( usesSession( authMode ) && sub ) {
    try {
      return await listWithCookie( apiUrl, sub );
    } catch ( error ) {
      onCookieError?.( error );
    }
  }
  const response = await workspaceService.listWorkspaces();

  return ( response?.data as ListWorkspacesReply )?.workspaces || [];
};
